import React from "react";
const IconBin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="bevel"
      strokeWidth="2"
      d="m5 6 1 11h8l1-11M5 6H3m2 0h2m8 0h2m-2 0h-2M7 6V3h6v3M7 6h6"
    />
  </svg>
);
export default IconBin;
